<template>
    <div v-loading.fullscreen="loading">
        <div class="header">
            <el-select v-model="territoryType" placeholder="Hudud turi" class="filter-item"
                @change="handleFilterChange">
                <el-option label="Tuman/Shahar" value="DISTRICT" />
                <el-option label="Viloyat" value="REGION" />
            </el-select>

            <el-select v-model="selectedYear" placeholder="Yil" class="filter-item" @change="handleFilterChange">
                <el-option v-for="year in years" :key="year" :label="year" :value="year" />
            </el-select>

            <el-select v-model="selectedQuarter" placeholder="Chorak" class="filter-item"
                @change="handleFilterChange">
                <el-option v-for="quarter in quarters" :key="quarter" :label="`${quarter}-chorak`"
                    :value="quarter" />
            </el-select>

            <el-input v-model="soato" placeholder="SOATO bo'yicha qidirish" class="filter-item" clearable
                @input="onSoatoInput" @clear="handleFilterChange" />

            <el-upload ref="uploadRef" class="upload-demo" :action="uploadQuartersUrl" :headers="uploadHeader"
                :multiple="false"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :limit="1" :on-exceed="onExceed" :on-success="onSuccessUpload" :on-error="onErrorUpload">
                <template #trigger>
                    <el-button style="width: 300px" type="success">
                        Excel orqali kiritish
                    </el-button>
                </template>
            </el-upload>
        </div>

        <el-table :data="reports" border height="calc(100vh - 210px)">
            <el-table-column type="index" min-width="50" label="№" />
            <el-table-column prop="title" label="Hudud nomi" min-width="250" />
            <el-table-column label="Hudud turi" min-width="120">
                <template #default="scope">
                    {{ scope.row.territory_type === "REGION" ? "Viloyat" : "Tuman/Shahar" }}
                </template>
            </el-table-column>
            <el-table-column prop="soato" label="SOATO" min-width="110" />
            <el-table-column prop="year" label="Yil" min-width="90" />
            <el-table-column label="Chorak" min-width="100">
                <template #default="scope">
                    {{ scope.row.quarter ? `${scope.row.quarter}-chorak` : "" }}
                </template>
            </el-table-column>
            <el-table-column label="Ijro (so'm)" min-width="180">
                <template #default="scope">
                    {{ formatAmount(scope.row.execution) }}
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
    name: "StateBudgetQuarterReports",
    data() {
        return {
            uploadQuartersUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/state-budget/revenue-reports/upload-excel`,
            uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
            loading: false,
            territoryType: "DISTRICT",
            selectedYear: new Date().getFullYear(),
            selectedQuarter: 1,
            quarters: [1, 2, 3, 4],
            soato: "",
            soatoTimer: null,
            reports: [],
        };
    },
    computed: {
        years() {
            const current = new Date().getFullYear();
            const list = [];
            for (let year = current; year >= current - 6; year--) {
                list.push(year);
            }
            return list;
        },
    },
    methods: {
        formatAmount(value) {
            if (value == null || value === "") return "";
            return Number(value).toLocaleString("ru-RU");
        },
        onSoatoInput(value) {
            this.soato = (value || "").replace(/\D/g, "");
            clearTimeout(this.soatoTimer);
            this.soatoTimer = setTimeout(() => {
                this.getReportList();
            }, 300);
        },
        handleFilterChange() {
            this.getReportList();
        },
        getReportList() {
            this.loading = true;
            this.$http
                .get("/api/v1/state-budget/revenue-reports", {
                    params: {
                        territory_type: this.territoryType,
                        year: this.selectedYear,
                        quarter: this.selectedQuarter,
                        soato: this.soato || undefined,
                    },
                })
                .then(({ data }) => {
                    this.reports = Array.isArray(data) ? data : data.reports || [];
                })
                .catch(({ response }) => {
                    ElNotification({
                        type: "error",
                        title: "Xatolik",
                        message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onSuccessUpload() {
            this.loading = false;
            ElNotification.success({
                message: "Amaliyot muvaffaqiyatli bajarildi!",
            });
            this.getReportList();
        },
        onErrorUpload(error) {
            if (error.status === 401) {
                this.$store.commit("signOut");
                this.$router.push({ name: "Auth" });
            }
            ElNotification.error({
                message:
                    JSON.parse(error?.message)?.message ||
                    "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
                type: "error",
            });

            this.loading = false;
        },
        onExceed(files) {
            console.log("exceeds", files);
        },
    },
    mounted() {
        this.getReportList();
    },
};
</script>

<style scoped>
.header {
    display: flex;
    margin-bottom: 10px;
    gap: 10px;
    align-items: center;
}

.filter-item {
    width: 200px;
}

.upload-demo {
    margin-left: auto;
}
</style>
